import { statusErrorsMessages } from '../../constants/statusErrorMessages.jsx';

type action = {
  type: string;
  error: any;
  errorData: {
    message: string;
    status: number;
  };
  provider: string;
  integrationId: string;
};

export const getInputErrors = (
  provider: string,
  action: action | undefined = undefined,
) => {
  const errorTypes = {
    APPSFLYER_DUPLICATED_KEY: 'This key already exists',
    APPSFLYER_INVALID_API_TOKEN: 'Appsflyer API token is invalid.',
    APPSFLYER_INVALID_ANDROID_ID: 'Appsflyer Android app id is invalid.',
    APPSFLYER_INVALID_IOS_ID: 'Appsflyer iOS app id is invalid.',
  };

  const errorResponses = {
    [errorTypes.APPSFLYER_DUPLICATED_KEY]:
      'You have already used this name for the another account. Please enter a new name.',
    [errorTypes.APPSFLYER_INVALID_API_TOKEN]:
      'Invalid credentials. Please check the values you entered and try again.',
    [errorTypes.APPSFLYER_INVALID_ANDROID_ID]:
      'The fulfilled APP ID is invalid. Please check the values you entered and try again.',
    [errorTypes.APPSFLYER_INVALID_IOS_ID]:
      'The fulfilled APP ID is invalid. Please check the values you entered and try again.',
  };

  const errorsByProviders: { [provider: string]: any } = {
    appsflyer: { name: '', apiToken: '', androidId: '', iosId: '' },
  };

  if (action !== undefined) {
    const errorMessage = getErrorMessageResponse(action);
    if (provider === 'appsflyer') {
      const name =
        errorMessage === errorTypes.APPSFLYER_DUPLICATED_KEY
          ? errorResponses[errorTypes.APPSFLYER_DUPLICATED_KEY]
          : '';
      const apiToken =
        errorMessage === errorTypes.APPSFLYER_INVALID_API_TOKEN
          ? errorResponses[errorTypes.APPSFLYER_INVALID_API_TOKEN]
          : '';
      const androidId =
        errorMessage === errorTypes.APPSFLYER_INVALID_ANDROID_ID
          ? errorResponses[errorTypes.APPSFLYER_INVALID_ANDROID_ID]
          : '';
      const iosId =
        errorMessage === errorTypes.APPSFLYER_INVALID_IOS_ID
          ? errorResponses[errorTypes.APPSFLYER_INVALID_IOS_ID]
          : '';

      errorsByProviders.appsflyer = { name, apiToken, androidId, iosId };
    }
  }

  return errorsByProviders[provider] || {};
};

export const getErrorDetailsResponse = (action: action) => {
  let errorDetails = '';
  if (action.provider !== 'appsflyer') {
    errorDetails = action.errorData.message;
  }

  return errorDetails;
};

export const getErrorMessageResponse = (action: action) => {
  let errorMessage = 'Something went wrong';
  if (action.provider === 'appsflyer') {
    errorMessage = getApsflyerError(action).message; //need to check it with localization
  }
  if (action.provider === 'campaign_manager') {
    switch (action?.errorData?.message) {
      case statusErrorsMessages.IncorrectAccount:
        errorMessage = statusErrorsMessages.IncorrectAccount;
        break;
      case statusErrorsMessages.IncorrectAdvertiser:
        errorMessage = statusErrorsMessages.IncorrectAdvertiser;
        break;
      case statusErrorsMessages.IncorrectAttributionModel:
        errorMessage = statusErrorsMessages.IncorrectAttributionModel;
        break;
      case statusErrorsMessages.IncorrectProfileForAdvertiser:
        errorMessage = statusErrorsMessages.IncorrectProfileForAdvertiser;
        break;
      default:
        break;
    }
  }

  return errorMessage;
};

export const getApsflyerError = (action: action) => {
  return action.errorData;
};
